const newReportDialog = {
  state: {
    status: false,
    files: [],
    report_name: '',
    salesGTLCode: ''
  },
  mutations: {
    setNewReportDialogStatus (state:any, payload:any) {
      state.status = payload
    },
    reSetNewReportDialog (state:any) {
      state.files = []
    }
  }
}
export default newReportDialog
